/* ============================================================
   GLOWGIRL — front end
   Restrained by design: no parallax, no scroll-jacking.
   ============================================================ */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- mobile drawer ---------- */
  (function drawer() {
    var el = $('[data-drawer]');
    if (!el) return;
    var openBtn = $('[data-drawer-open]');
    var closeBtn = $('[data-drawer-close]');

    function set(open) {
      el.setAttribute('data-open', open ? 'true' : 'false');
      el.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }
    if (openBtn) openBtn.addEventListener('click', function () { set(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { set(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') set(false);
    });
  })();

  /* ---------- product ---------- */
  var root = $('[data-product-root]');
  if (!root) return;

  var moneyFormat = root.getAttribute('data-money-format') || '&euro;{{amount}}';
  var cartUrl = root.getAttribute('data-cart-url') || '/cart';
  var promoPct = parseFloat(root.getAttribute('data-promo-pct')) || 0;
  var subPct = parseFloat(root.getAttribute('data-sub-pct')) || 0;

  // Every price the shopper sees is the post-sale price, so the CTA total
  // and the checkout total agree.
  function afterPromo(cents) {
    if (!promoPct) return cents;
    return Math.round(cents * (100 - promoPct) / 100);
  }
  var subCents = parseInt(root.getAttribute('data-sub-cents'), 10) || 0;

  // A flat subscription price is quoted per single bottle. For multi-packs
  // fall back to the equivalent percentage so the two never contradict.
  function subscriptionUnit(price, count) {
    if (subCents && count === 1) return subCents;
    return Math.round(price * (1 - subPct / 100));
  }

  // Count a displayed price toward its new value rather than snapping.
  function rollTo(el, from, to, suffix) {
    if (!el) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.innerHTML = formatMoney(to) + (suffix || '');
      return;
    }
    var start = null, dur = 320;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      el.innerHTML = formatMoney(Math.round(from + (to - from) * eased)) + (suffix || '');
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function formatMoney(cents) {
    var value = (cents / 100);
    // Match Shopify's placeholder styles.
    var withComma = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var euroStyle = value.toFixed(2).replace('.', ',');

    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, euroStyle.replace(/\B(?=(\d{3})+(?!\d),)/g, '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, withComma);
  }

  /* ---------- media: thumbnails + dots crossfade ---------- */
  (function media() {
    var slides = $$('[data-slide]');
    var pickers = $$('[data-thumb]');
    if (!slides.length) return;

    function show(index) {
      slides.forEach(function (s) {
        s.setAttribute('data-active', s.getAttribute('data-slide') === String(index) ? 'true' : 'false');
      });
      pickers.forEach(function (p) {
        p.setAttribute('aria-selected', p.getAttribute('data-thumb') === String(index) ? 'true' : 'false');
      });
    }

    pickers.forEach(function (p) {
      p.addEventListener('click', function () { show(parseInt(p.getAttribute('data-thumb'), 10)); });
    });

    /* ---- arrows, counter, keyboard and swipe ---- */
    var current = 0;
    var total = slides.length;
    var prevBtn = $('[data-media-prev]');
    var nextBtn = $('[data-media-next]');
    var counter = $('[data-media-counter]');
    var frame = $('.media__frame');

    function go(index) {
      // wrap around so the last image steps forward to the first
      current = (index + total) % total;
      show(current);
      if (counter) counter.textContent = (current + 1) + ' / ' + total;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(current + 1); });

    pickers.forEach(function (p) {
      p.addEventListener('click', function () { go(parseInt(p.getAttribute('data-thumb'), 10)); });
    });

    if (frame) {
      frame.setAttribute('tabindex', '0');
      frame.setAttribute('role', 'group');
      frame.setAttribute('aria-label', 'Product images');
      frame.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      });

      var startX = 0, startY = 0, tracking = false;
      frame.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });

      frame.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        // horizontal intent only, so vertical page scroll is never hijacked
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        go(dx < 0 ? current + 1 : current - 1);
      }, { passive: true });
    }

    go(0);

    var ribbonClose = $('[data-ribbon-close]');
    if (ribbonClose) {
      ribbonClose.addEventListener('click', function () {
        var r = $('[data-ribbon]');
        if (r) r.hidden = true;
      });
    }

    var zoom = $('[data-zoom]');
    if (zoom) {
      zoom.addEventListener('click', function () {
        var active = slides.filter(function (s) { return s.getAttribute('data-active') === 'true'; })[0];
        var img = active && active.querySelector('img');
        if (img) window.open(img.currentSrc || img.src, '_blank', 'noopener');
      });
    }
  })();

  /* ---------- tabs ---------- */
  (function tabs() {
    var btns = $$('[data-tab]');
    var panels = $$('[data-panel]');
    if (!btns.length) return;

    function activate(name) {
      btns.forEach(function (b) {
        b.setAttribute('aria-selected', b.getAttribute('data-tab') === name ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-panel') !== name;
      });
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () { activate(b.getAttribute('data-tab')); });
    });

    $$('[data-jump-tab]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        activate(a.getAttribute('data-jump-tab'));
        var card = $('.buycard');
        if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
  })();

  /* ---------- see benefits accordion ---------- */
  (function benefits() {
    var toggle = $('[data-benefits-toggle]');
    var panel = $('[data-benefits-panel]');
    var sign = $('[data-benefits-sign]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var open = panel.getAttribute('data-open') === 'true';
      panel.setAttribute('data-open', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (sign) sign.textContent = open ? '+' : '–';
    });
  })();

  /* ---------- buy card state ---------- */
  var state = {
    variantId: null,
    price: 0,
    purchase: 'onetime',
    count: 1,
    sellingPlan: null,
    qty: 1
  };

  var variantInput  = $('[data-variant-input]');
  var planInput     = $('[data-selling-plan-input]');
  var qtyInput      = $('[data-qty-input]');
  var ctaText       = $('[data-cta-text]');
  var cta           = $('[data-cta]');
  var stickyPrice   = $('[data-sticky-price]');
  var priceOnetime  = $('[data-price-onetime]');
  var priceStrike   = $('[data-price-strike]');
  var priceSub      = $('[data-price-sub]');
  var lastTotal     = 0;

  function subtotal() {
    var unit = state.price;
    if (state.purchase === 'subscribe') unit = subscriptionUnit(unit, state.count);
    return afterPromo(unit) * state.qty;
  }

  function render() {
    if (variantInput) variantInput.value = state.variantId || '';

    if (planInput) {
      if (state.purchase === 'subscribe' && state.sellingPlan) {
        planInput.value = state.sellingPlan;
        planInput.disabled = false;
      } else {
        planInput.value = '';
        planInput.disabled = true;
      }
    }

    if (priceOnetime) priceOnetime.textContent = formatMoney(afterPromo(state.price));
    if (priceStrike) priceStrike.textContent = formatMoney(state.price);
    if (priceSub) priceSub.textContent = formatMoney(subscriptionUnit(state.price, state.count));

    var total = subtotal();
    if (addon && addon.on) total += afterPromo(addonPrice());

    rollTo(ctaText, lastTotal, total, ' &ndash; Add to bag');
    rollTo(stickyPrice, lastTotal, total, '');
    lastTotal = total;

    renderAddon();
    renderUnlock();
    syncStickyPacks();
  }

  /* bundle tiles */
  var bundles = $$('[data-bundle]');
  bundles.forEach(function (b) {
    b.addEventListener('click', function () {
      bundles.forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
      b.setAttribute('aria-checked', 'true');
      state.variantId = b.getAttribute('data-variant-id');
      state.price = parseInt(b.getAttribute('data-price'), 10) || 0;
      state.count = parseInt(b.getAttribute('data-count'), 10) || 1;
      var available = b.getAttribute('data-available') === 'true';
      if (cta) cta.disabled = !available;
      render();
    });
  });

  var checked = bundles.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0] || bundles[0];
  if (checked) {
    state.variantId = checked.getAttribute('data-variant-id');
    state.price = parseInt(checked.getAttribute('data-price'), 10) || 0;
    state.count = parseInt(checked.getAttribute('data-count'), 10) || 1;
  }

  /* purchase type */
  var rows = $$('[data-purchase]');
  rows.forEach(function (r) {
    r.addEventListener('click', function () {
      if (r.disabled) return;
      rows.forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
      r.setAttribute('aria-checked', 'true');
      var kind = r.getAttribute('data-purchase');
      state.purchase = kind === 'subscribe' ? 'subscribe' : 'onetime';
      state.sellingPlan = r.getAttribute('data-selling-plan');
      render();
    });
  });

  /* quantity */
  function setQty(n) {
    state.qty = Math.max(1, n || 1);
    if (qtyInput) qtyInput.value = state.qty;
    render();
  }
  var minus = $('[data-qty-minus]');
  var plus = $('[data-qty-plus]');
  if (minus) minus.addEventListener('click', function () { setQty(state.qty - 1); });
  if (plus) plus.addEventListener('click', function () { setQty(state.qty + 1); });
  if (qtyInput) qtyInput.addEventListener('change', function () { setQty(parseInt(qtyInput.value, 10)); });

  /* ---------- order add-on ---------- */
  var addonEl = $('[data-addon]');
  var addonToggle = $('[data-addon-toggle]');
  var addonWas = $('[data-addon-was]');
  var addonNow = $('[data-addon-now]');
  var addonHint = $('[data-addon-hint]');

  var addonSaving = $('[data-addon-saving]');

  var addon = addonEl ? {
    variantId: addonEl.getAttribute('data-variant-id'),
    price: parseInt(addonEl.getAttribute('data-price'), 10) || 0,
    freeFrom: parseInt(addonEl.getAttribute('data-free-from'), 10) || 0,
    tierPack: parseInt(addonEl.getAttribute('data-tier-pack'), 10) || 0,
    tierPrice: parseInt(addonEl.getAttribute('data-tier-price'), 10) || 0,
    on: !!(addonToggle && addonToggle.checked)
  } : null;

  // What the guide actually costs at the currently selected pack size.
  // These tiers mirror the automatic discounts in Shopify — if you change
  // one, change the other, or the cart total will not match this figure.
  function addonPrice() {
    if (!addon) return 0;
    if (addon.freeFrom > 0 && state.count >= addon.freeFrom) return 0;
    if (addon.tierPack > 0 && addon.tierPrice > 0 && state.count >= addon.tierPack) return addon.tierPrice;
    return addon.price;
  }

  function addonIsFree() { return addon ? addonPrice() === 0 : false; }

  function renderAddon() {
    if (!addon || !addonEl) return;
    addonEl.setAttribute('data-on', addon.on ? 'true' : 'false');

    var now = addonPrice();
    var saved = addon.price - now;

    if (addonWas) addonWas.hidden = saved <= 0;
    if (addonNow) {
      if (now === 0) {
        addonNow.textContent = 'FREE';
        addonNow.className = 'addon__free';
      } else {
        addonNow.textContent = formatMoney(now);
        addonNow.className = saved > 0 ? 'addon__free' : '';
      }
    }

    if (addonSaving) {
      if (saved > 0) {
        addonSaving.hidden = false;
        addonSaving.textContent = 'You save ' + formatMoney(saved) + ' on the guide with this bundle';
      } else {
        addonSaving.hidden = true;
      }
    }

    // Only nudge toward the free tier when they are not already getting it
    if (addonHint) addonHint.hidden = (now === 0) || addon.freeFrom <= 0;
  }

  if (addonToggle) {
    addonToggle.addEventListener('change', function () {
      addon.on = addonToggle.checked;
      renderAddon();
    });
  }

  /* ---------- unlock progress toward the free guide ---------- */
  var unlockEl = $('[data-unlock]');
  var unlockFill = $('[data-unlock-fill]');
  var unlockText = $('[data-unlock-text]');

  function renderUnlock() {
    if (!unlockEl || !addon || addon.freeFrom <= 0) return;
    var target = addon.freeFrom;
    var have = Math.min(state.count, target);
    var pct = Math.round((have / target) * 100);

    unlockEl.hidden = false;
    if (unlockFill) unlockFill.style.width = pct + '%';
    if (unlockText) {
      var short = target - have;
      unlockText.textContent = short <= 0
        ? 'Unlocked — the guide is included free'
        : 'Add ' + short + ' more bottle' + (short > 1 ? 's' : '') + ' to get the guide free';
    }
  }

  /* ---------- sticky pack pills mirror the tiles ---------- */
  var stickyPacks = $$('[data-sticky-pack-btn]');
  var stickyPackLabel = $('[data-sticky-pack]');

  function syncStickyPacks() {
    stickyPacks.forEach(function (p) {
      p.setAttribute('aria-pressed', parseInt(p.getAttribute('data-count'), 10) === state.count ? 'true' : 'false');
    });
    var active = bundles.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0];
    if (stickyPackLabel && active) {
      var label = active.querySelector('.bundle__label');
      if (label) stickyPackLabel.textContent = label.textContent;
    }
  }

  stickyPacks.forEach(function (p) {
    p.addEventListener('click', function () {
      var want = parseInt(p.getAttribute('data-count'), 10);
      var match = bundles.filter(function (b) { return parseInt(b.getAttribute('data-count'), 10) === want; })[0];
      if (match) match.click();
    });
  });

  /* ---------- add to cart ---------- */
  var form = $('#BuyForm') || $('form[action*="/cart/add"]');

  function addToCart() {
    if (!form) return;
    if (cta) { cta.disabled = true; }

    var items = [{ id: state.variantId, quantity: state.qty }];
    if (state.purchase === 'subscribe' && state.sellingPlan) {
      items[0].selling_plan = state.sellingPlan;
    }
    if (addon && addon.on && addon.variantId) {
      items.push({ id: addon.variantId, quantity: 1 });
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        if (window.GlowCart && window.GlowCart.refresh) {
          if (ctaText) ctaText.textContent = 'Added';
          setTimeout(render, 900);
          return window.GlowCart.refresh(true);
        }
        window.location.href = cartUrl;
      })
      .catch(function () {
        // Fall back to a normal form post so the customer is never stuck.
        form.submit();
      })
      .finally(function () {
        if (cta) cta.disabled = false;
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart();
    });
  }

  var stickyCta = $('[data-sticky-cta]');
  if (stickyCta) stickyCta.addEventListener('click', addToCart);

  /* ---------- mobile sticky bar visibility ---------- */
  (function stickybar() {
    var bar = $('[data-stickybar]');
    var anchor = $('[data-cta]') || $('.buycard');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    // Visible only once the in-card button has scrolled past, so the bar
    // never competes with the real CTA while it is still on screen.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.setAttribute('data-visible', past ? 'true' : 'false');
      });
    }, { threshold: 0 });

    io.observe(anchor);
  })();

  render();
})();

/* ============================================================
   Below-the-fold behaviour. Separate IIFE so it still runs on
   pages where the buy card isn't present.
   ============================================================ */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- reviews: filter chips + load more ---------- */
  (function reviews() {
    var grid = $('[data-reviews-grid]');
    if (!grid) return;

    var cards = $$('.review', grid);
    var chips = $$('[data-review-filter]');
    var more = $('[data-reviews-more]');
    var PAGE = parseInt(grid.getAttribute('data-per-page'), 10) || 9;
    var shown = PAGE;
    var mode = 'recent';

    function matches(card) {
      if (mode !== 'photos') return true;
      return card.getAttribute('data-has-photo') === 'true';
    }

    function apply() {
      var pool = cards.filter(matches);

      if (mode === 'rated') {
        pool.sort(function (a, b) {
          return parseInt(b.getAttribute('data-rating'), 10) - parseInt(a.getAttribute('data-rating'), 10);
        });
      }

      cards.forEach(function (c) { c.hidden = true; });
      pool.slice(0, shown).forEach(function (c) { c.hidden = false; });

      // Re-append in sorted order so the masonry columns reflow correctly.
      pool.forEach(function (c) { grid.appendChild(c); });

      if (more) more.hidden = pool.length <= shown;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        mode = chip.getAttribute('data-review-filter');
        shown = PAGE;
        apply();
      });
    });

    if (more) {
      more.addEventListener('click', function () { shown += PAGE; apply(); });
    }

    apply();
  })();

  /* ---------- repeated bundle block ---------- */
  (function bundleRepeat() {
    var form = $('[data-bundle-form]');
    if (!form) return;

    var tiles = $$('[data-bundle2]', form);
    var input = $('[data-bundle2-input]', form);
    var label = $('[data-bundle2-text]', form);

    function select(tile) {
      tiles.forEach(function (t) { t.setAttribute('aria-checked', 'false'); });
      tile.setAttribute('aria-checked', 'true');
      if (input) input.value = tile.getAttribute('data-variant-id');
      var total = tile.querySelector('.bundle__total');
      if (label) label.textContent = total ? total.textContent + ' – Add to bag' : 'Add to bag';
    }

    tiles.forEach(function (t) {
      t.addEventListener('click', function () { select(t); });
    });

    var initial = tiles.filter(function (t) { return t.getAttribute('aria-checked') === 'true'; })[0] || tiles[0];
    if (initial) select(initial);
  })();

  /* ---------- respect reduced motion on the marquees ---------- */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    $$('.marquee__track, .proofstrip__track, .freefrom__track').forEach(function (t) {
      t.style.animation = 'none';
    });
  }
})();

/* ============================================================
   Video loop + image comparison
   ============================================================ */
(function () {
  'use strict';
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- looping video ---------- */
  $$('.videoloop').forEach(function (wrap) {
    var video = $('.videoloop__video', wrap);
    var btn = $('[data-video-toggle]', wrap);
    if (!video) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      video.removeAttribute('autoplay');
      video.pause();
    }

    // Some browsers refuse autoplay until the element is muted and in view.
    video.muted = true;
    var tryPlay = function () {
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* user gesture required — the toggle covers it */ });
    };
    if (!reduce) tryPlay();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (reduce) return;
          if (e.isIntersecting) tryPlay(); else video.pause();
        });
      }, { threshold: 0.15 }).observe(video);
    }

    if (btn) {
      var pauseIcon = $('[data-video-pause]', btn);
      var playIcon = $('[data-video-play]', btn);
      var sync = function () {
        var paused = video.paused;
        if (pauseIcon) pauseIcon.hidden = paused;
        if (playIcon) playIcon.hidden = !paused;
        btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      };
      btn.addEventListener('click', function () {
        if (video.paused) tryPlay(); else video.pause();
        sync();
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      sync();
    }
  });

  /* ---------- image comparison wipe ---------- */
  $$('[data-compare]').forEach(function (root) {
    var clip = $('[data-compare-clip]', root);
    var handle = $('[data-compare-handle]', root);
    var range = $('[data-compare-range]', root);
    var inner = clip && clip.querySelector('img');
    if (!clip || !range) return;

    function sizeInner() {
      // The clipped image must stay the full width of the frame, not the clip.
      if (inner) inner.style.width = root.clientWidth + 'px';
    }

    function set(pct) {
      clip.style.width = pct + '%';
      if (handle) handle.style.left = pct + '%';
    }

    range.addEventListener('input', function () { set(range.value); });
    window.addEventListener('resize', sizeInner);
    sizeInner();
    set(range.value);
  });
})();

/* ============================================================
   Reveal on scroll — additive, never blocks first paint
   ============================================================ */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var targets = Array.prototype.slice.call(
    document.querySelectorAll('.panel, .ingredient, .timeline__step, .step, .videoloop__frame, .bcards, .inglist__row, .badgerow')
  );
  if (!targets.length) return;

  targets.forEach(function (el) { el.classList.add('reveal'); });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  targets.forEach(function (el) { io.observe(el); });

  // Safety net: if anything never intersects, reveal it after 2s
  // so content can't be permanently hidden by a layout quirk.
  setTimeout(function () {
    targets.forEach(function (el) { el.classList.add('is-in'); });
  }, 2000);
})();

/* ============================================================
   Cart: remove and quantity, via the AJAX API with a form fallback
   ============================================================ */
(function () {
  'use strict';
  var form = document.querySelector('[data-cart-form]');
  if (!form) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function change(line, quantity, lineEl) {
    if (lineEl) lineEl.setAttribute('data-removing', 'true');

    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart change failed');
        return r.json();
      })
      .then(function () {
        // Re-render server-side so totals, free-delivery threshold and
        // discounts all recalculate rather than being patched in JS.
        window.location.reload();
      })
      .catch(function () {
        if (lineEl) lineEl.removeAttribute('data-removing');
        form.submit();
      });
  }

  form.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      var el = remove.closest('[data-cart-line]');
      change(parseInt(remove.getAttribute('data-line'), 10), 0, el);
      return;
    }

    var step = e.target.closest('[data-qty-change]');
    if (step) {
      e.preventDefault();
      var to = parseInt(step.getAttribute('data-to'), 10);
      var lineEl = step.closest('[data-cart-line]');
      // stepping below 1 removes the line, which is what a shopper expects
      change(parseInt(step.getAttribute('data-line'), 10), Math.max(0, to), to <= 0 ? lineEl : null);
    }
  });

  form.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 1;
    change(parseInt(input.getAttribute('data-line'), 10), qty,
           qty === 0 ? input.closest('[data-cart-line]') : null);
  });
})();

/* ============================================================
   Cart drawer — shared, used by every add-to-cart on the page
   ============================================================ */
window.GlowCart = (function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };

  var drawer = $('[data-cart-drawer]');
  var overlay = $('[data-cart-overlay]');
  if (!drawer) return { open: function () {}, refresh: function () {} };

  var body = $('[data-cart-drawer-body]');
  var foot = $('[data-cart-foot]');
  var countEl = $('[data-cart-drawer-count]');
  var subtotalEl = $('[data-cart-subtotal]');
  var lastFocus = null;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var moneyFormat = (document.querySelector('[data-product-root]') || {}).getAttribute
    ? document.querySelector('[data-product-root]').getAttribute('data-money-format')
    : null;

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    if (!moneyFormat) return '€' + v;
    return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/g, v);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function open() {
    lastFocus = document.activeElement;
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.setAttribute('data-open', 'true'); }); }
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.setAttribute('data-drawer-open', 'true');
    var close = $('[data-cart-close]', drawer);
    if (close) close.focus();
  }

  function close() {
    drawer.setAttribute('data-open', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.removeAttribute('data-drawer-open');
    if (overlay) {
      overlay.setAttribute('data-open', 'false');
      setTimeout(function () { overlay.hidden = true; }, 260);
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function render(cart) {
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';
    var badge = $('[data-cart-count]');
    if (badge) badge.textContent = cart.item_count;

    if (!cart.items.length) {
      body.innerHTML = '<p class="cartdrawer__empty">Your bag is empty.</p>';
      if (foot) foot.hidden = true;
      (window.GlowCartHooks || []).forEach(function (fn) { try { fn(cart); } catch (e) {} });
      return;
    }

    body.innerHTML = cart.items.map(function (item, i) {
      var line = i + 1;
      var free = item.final_line_price === 0;
      return '' +
        '<div class="dline" data-dline="' + line + '">' +
          '<a href="' + esc(item.url) + '">' +
            (item.image ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_140x140$1$2')) + '" alt="" width="66" height="66">' : '') +
          '</a>' +
          '<div>' +
            '<a class="dline__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
            (item.variant_title && item.variant_title.indexOf('Default') === -1
              ? '<p class="dline__variant">' + esc(item.variant_title) + '</p>' : '') +
            (free ? '<span class="dline__free">Included free</span>' : '') +
            '<div class="dline__controls">' +
              '<div class="dline__qty">' +
                '<button type="button" data-dq="' + line + '" data-to="' + (item.quantity - 1) + '" aria-label="Decrease">&minus;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-dq="' + line + '" data-to="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
              '</div>' +
              '<button class="dline__remove" type="button" data-dr="' + line + '">Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="dline__price">' + (free ? 'FREE' : money(item.final_line_price)) + '</div>' +
        '</div>';
    }).join('');

    if (foot) foot.hidden = false;
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    (window.GlowCartHooks || []).forEach(function (fn) { try { fn(cart); } catch (e) {} });
  }

  function refresh(andOpen) {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); if (andOpen) open(); return cart; })
      .catch(function () { if (andOpen) window.location.href = root + 'cart'; });
  }

  function change(line, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { window.location.href = root + 'cart'; });
  }

  drawer.addEventListener('click', function (e) {
    var c = e.target.closest('[data-cart-close]');
    if (c) { close(); return; }
    var q = e.target.closest('[data-dq]');
    if (q) { change(parseInt(q.getAttribute('data-dq'), 10), parseInt(q.getAttribute('data-to'), 10)); return; }
    var r = e.target.closest('[data-dr]');
    if (r) change(parseInt(r.getAttribute('data-dr'), 10), 0);
  });

  if (overlay) overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') close();
  });

  // Open the drawer from the header bag rather than navigating away
  var bagLink = document.querySelector('.header__bag');
  if (bagLink) {
    bagLink.addEventListener('click', function (e) {
      e.preventDefault();
      refresh(true);
    });
  }

  return { open: open, close: close, refresh: refresh };
})();

/* ============================================================
   Discount code box (cart drawer and cart page)

   Shopify has no storefront API for applying a code to the cart, so we
   hit /discount/CODE which stores it against the session. It then shows
   as applied at checkout. We verify the code exists first so a typo gives
   immediate feedback instead of a silent no-op at checkout.
   ============================================================ */
(function () {
  'use strict';

  function wire(box) {
    var input = box.querySelector('[data-code-input]');
    var btn = box.querySelector('[data-code-apply]');
    var msg = box.parentNode.querySelector('[data-code-msg]');
    if (!input || !btn) return;

    function say(text, state) {
      if (!msg) return;
      msg.hidden = false;
      msg.textContent = text;
      msg.setAttribute('data-state', state);
    }

    function apply() {
      var code = (input.value || '').trim().toUpperCase();
      if (!code) { say('Enter a code first.', 'err'); return; }

      btn.disabled = true;
      say('Checking…', 'ok');

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      // /discount/CODE sets the session, then we land back on the cart.
      fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js'), {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json().catch(function () { return null; }); })
        .then(function () {
          say(code + ' applied — you will see it at checkout.', 'ok');
          input.value = '';
          if (window.GlowCart && window.GlowCart.refresh) window.GlowCart.refresh(false);
        })
        .catch(function () {
          // The redirect still sets the session even if the fetch is opaque,
          // so send them to checkout rather than blocking on a network quirk.
          say(code + ' applied — you will see it at checkout.', 'ok');
        })
        .finally(function () { btn.disabled = false; });
    }

    btn.addEventListener('click', apply);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); apply(); }
    });
  }

  Array.prototype.slice.call(document.querySelectorAll('[data-codebox]')).forEach(wire);

  // The drawer footer is present from page load, but re-wire after a refresh
  // in case the markup was replaced.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cart-drawer]')) return;
    Array.prototype.slice.call(document.querySelectorAll('[data-codebox]')).forEach(function (b) {
      if (!b.hasAttribute('data-wired')) { b.setAttribute('data-wired', '1'); wire(b); }
    });
  });
})();

/* ============================================================
   Discount code: shown and copyable, never applied automatically.
   The customer types or pastes it at checkout, so the discount is
   something they opted into rather than something we granted silently.
   ============================================================ */
(function () {
  'use strict';

  function flash(el, text) {
    var tag = el.querySelector('[data-offerbar-cta]');
    if (!tag) return;
    var was = tag.textContent;
    tag.textContent = text;
    el.setAttribute('data-done', 'true');
    setTimeout(function () {
      tag.textContent = was;
      el.removeAttribute('data-done');
    }, 1800);
  }

  document.addEventListener('click', function (e) {
    var bar = e.target.closest('[data-copy-preset]');
    if (!bar) return;
    e.preventDefault();
    var code = bar.getAttribute('data-copy-preset');
    if (!code) return;

    // Drop it into the code box if one is on screen, so it is one tap to use
    // but still requires them to press Apply.
    var box = document.querySelector('[data-code-input]');
    if (box) { box.value = code; box.focus(); }

    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).then(function () { flash(bar, 'Copied'); })
                                         .catch(function () { flash(bar, 'Copied'); });
    } else {
      flash(bar, 'Copied');
    }
  });
})();


/* ============================================================
   Announcement: one message at a time (Seed-style)
   ============================================================ */
(function () {
  'use strict';
  var bars = document.querySelectorAll('[data-rotator]');
  if (!bars.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  Array.prototype.forEach.call(bars, function (bar) {
    var msgs = bar.querySelectorAll('.marquee__msg');
    if (msgs.length < 2 || reduce) return;
    var i = 0;
    setInterval(function () {
      var cur = msgs[i];
      i = (i + 1) % msgs.length;
      var next = msgs[i];
      cur.classList.add('is-out');
      setTimeout(function () {
        cur.hidden = true;
        cur.classList.remove('is-out');
        next.hidden = false;
      }, 280);
    }, 4200);
  });
})();

/* ============================================================
   Timeline tabs (Seed-style)
   ============================================================ */
(function () {
  'use strict';
  Array.prototype.forEach.call(document.querySelectorAll('[data-ttabs]'), function (root) {
    var pills = root.querySelectorAll('[data-ttab]');
    var panels = root.querySelectorAll('[data-tpanel]');
    Array.prototype.forEach.call(pills, function (pill) {
      pill.addEventListener('click', function () {
        var k = pill.getAttribute('data-ttab');
        Array.prototype.forEach.call(pills, function (p) { p.setAttribute('aria-selected', p === pill ? 'true' : 'false'); });
        Array.prototype.forEach.call(panels, function (p) { p.hidden = p.getAttribute('data-tpanel') !== k; });
      });
    });
  });
})();

/* ============================================================
   UGC video reel
   - loads + plays muted only while a card is on screen
   - tap opens a full-screen player with sound
   - quick add-to-bag on each card
   - optional floating bubble that opens the first video
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-ugc]');
  if (!root) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ugc-card]'));
  var modal = root.querySelector('[data-ugc-modal]');
  var modalVideo = root.querySelector('[data-ugc-modal-video]');
  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function ensureSrc(video) {
    if (video && !video.getAttribute('src') && video.dataset.src) {
      video.setAttribute('src', video.dataset.src);
    }
  }
  function tryPlay(video) {
    ensureSrc(video);
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  /* play while visible */
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target.querySelector('video');
        if (!v) return;
        if (e.isIntersecting && e.intersectionRatio > 0.55) tryPlay(v); else v.pause();
      });
    }, { threshold: [0, 0.55, 1] });
    cards.forEach(function (c) { io.observe(c); });
  }

  /* full-screen player */
  function openVideo(src, poster) {
    if (!modal || !modalVideo) return;
    cards.forEach(function (c) { var v = c.querySelector('video'); if (v) v.pause(); });
    modalVideo.src = src;
    if (poster) modalVideo.poster = poster; else modalVideo.removeAttribute('poster');
    modalVideo.muted = false;
    if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open', '');
    document.documentElement.classList.add('has-ugc-modal');
    var p = modalVideo.play();
    if (p && p.catch) p.catch(function () {});
  }
  function closeVideo() {
    if (!modal) return;
    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalVideo.load();
    if (typeof modal.close === 'function' && modal.open) modal.close(); else modal.removeAttribute('open');
    document.documentElement.classList.remove('has-ugc-modal');
  }
  cards.forEach(function (card) {
    var v = card.querySelector('video');
    var open = card.querySelector('[data-ugc-open]');
    function go() { if (v) openVideo(v.dataset.src, v.getAttribute('poster')); }
    if (open) open.addEventListener('click', go);
    if (v) v.addEventListener('click', go);
  });
  if (modal) {
    var closeBtn = modal.querySelector('[data-ugc-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeVideo);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeVideo(); });
    modal.addEventListener('cancel', function (e) { e.preventDefault(); closeVideo(); });
  }

  /* quick add */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ugc-add]');
    if (!btn) return;
    var label = btn.querySelector('[data-ugc-add-text]');
    var was = label ? label.textContent : '';
    btn.disabled = true;
    fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: btn.getAttribute('data-variant-id'), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (label) label.textContent = 'Added ✓';
        if (window.GlowCart && window.GlowCart.refresh) window.GlowCart.refresh(true);
        setTimeout(function () { if (label) label.textContent = was; }, 1800);
      })
      .catch(function () { window.location.href = shopRoot + 'cart'; })
      .finally(function () { btn.disabled = false; });
  });

  /* smooth jump from the buy box link */
  Array.prototype.forEach.call(document.querySelectorAll('[data-ugc-jump]'), function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* floating bubble */
  var bubble = root.querySelector('[data-ugc-bubble]');
  var first = cards[0] && cards[0].querySelector('video');
  if (bubble && first) {
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('gg-ugc-bubble') === 'off'; } catch (err) {}
    var bv = bubble.querySelector('[data-ugc-bubble-video]');
    var reelInView = false;
    function sync() {
      var show = !dismissed && !reelInView && window.scrollY > 500;
      bubble.hidden = !show;
      if (show && bv && !reduce) {
        if (!bv.getAttribute('src')) { bv.src = first.dataset.src; if (first.getAttribute('poster')) bv.poster = first.getAttribute('poster'); }
        var p = bv.play(); if (p && p.catch) p.catch(function () {});
      } else if (bv) { bv.pause(); }
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { reelInView = en[0].isIntersecting; sync(); }, { threshold: 0.15 }).observe(root.querySelector('[data-ugc-row]') || root);
    }
    window.addEventListener('scroll', sync, { passive: true });
    bubble.querySelector('[data-ugc-bubble-open]').addEventListener('click', function () {
      openVideo(first.dataset.src, first.getAttribute('poster'));
    });
    bubble.querySelector('[data-ugc-bubble-close]').addEventListener('click', function () {
      dismissed = true;
      try { sessionStorage.setItem('gg-ugc-bubble', 'off'); } catch (err) {}
      sync();
    });
    sync();
  }
})();


/* ============================================================
   Bag nudges: progress to the free gift, and a one-tap upgrade
   to the next pack size. Both read the live bag, so they only
   ever show what is actually true for it.
   ============================================================ */
(function () {
  'use strict';
  var box = document.querySelector('[data-cart-nudge]');
  if (!box) return;
  var goalEl = box.querySelector('[data-cart-goal]');
  var goalText = box.querySelector('[data-cart-goal-text]');
  var goalFill = box.querySelector('[data-cart-goal-fill]');
  var goalAdd = box.querySelector('[data-cart-goal-add]');
  var upEl = box.querySelector('[data-cart-up]');
  var upText = box.querySelector('[data-cart-up-text]');
  var upGo = box.querySelector('[data-cart-up-go]');
  var bottleHandle = box.getAttribute('data-bottle-handle');
  var giftHandle = box.getAttribute('data-gift-handle');
  var giftVariant = box.getAttribute('data-gift-variant');
  var giftName = box.getAttribute('data-gift-name') || 'gift';
  var goal = parseInt(box.getAttribute('data-goal'), 10) || 3;
  var allowUp = box.getAttribute('data-upgrade') === 'true';
  var packs = [];
  try { packs = JSON.parse(box.getAttribute('data-packs') || '[]'); } catch (e) {}
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var eur = function (c) { return '\u20ac' + (c / 100).toFixed(2).replace('.', ','); };
  var countOf = function (item) { var n = parseInt(item.variant_title, 10); return n > 0 ? n : 1; };
  var pending = null;

  function post(url, data) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
  }
  function refresh() { if (window.GlowCart && window.GlowCart.refresh) window.GlowCart.refresh(false); }

  function update(cart) {
    var bottles = 0, giftIn = false, lines = [];
    (cart.items || []).forEach(function (it) {
      if (it.handle === bottleHandle) { bottles += countOf(it) * it.quantity; lines.push(it); }
      if (giftHandle && it.handle === giftHandle) giftIn = true;
    });
    box.hidden = bottles === 0;
    if (!bottles) return;

    /* gift progress */
    if (giftVariant && goalEl) {
      goalEl.hidden = false;
      var pct = Math.min(100, Math.round(bottles / goal * 100));
      goalFill.style.width = pct + '%';
      goalAdd.hidden = true;
      if (bottles < goal) {
        var more = goal - bottles;
        goalText.innerHTML = 'Add <strong>' + more + ' more bottle' + (more > 1 ? 's' : '') + '</strong> and the ' + giftName + ' is free';
      } else if (!giftIn) {
        goalText.innerHTML = 'You\u2019ve unlocked the free <strong>' + giftName + '</strong>';
        goalAdd.textContent = 'Add it free';
        goalAdd.hidden = false;
      } else {
        goalText.innerHTML = '\u2713 ' + giftName + ' included free';
      }
    }

    /* upgrade to the next pack size (single line, quantity 1 only) */
    upEl.hidden = true; pending = null;
    if (allowUp && lines.length === 1 && lines[0].quantity === 1) {
      var have = countOf(lines[0]);
      var next = packs.filter(function (p) { return p.count === have + 1; })[0];
      var one = packs.filter(function (p) { return p.count === 1; })[0];
      if (next && one) {
        var save = one.price * next.count - next.price;
        var extra = next.price - lines[0].final_line_price;
        var perDay = Math.round(next.price / (next.count * 30));
        var bonus = next.count >= goal && giftVariant ? ' + free ' + giftName : '';
        upText.innerHTML = '<strong>Switch to ' + next.count + ' bottles</strong> for ' + eur(extra) + ' more' +
          '<span>' + eur(perDay) + '/day \u00b7 save ' + eur(save).replace(',00', '') + bonus + '</span>';
        upEl.hidden = false;
        pending = { key: lines[0].key, id: next.id };
      }
    }
  }

  (window.GlowCartHooks = window.GlowCartHooks || []).push(update);

  if (goalAdd) goalAdd.addEventListener('click', function () {
    goalAdd.disabled = true;
    post('cart/add.js', { items: [{ id: giftVariant, quantity: 1 }] }).then(refresh).catch(refresh)
      .finally(function () { goalAdd.disabled = false; });
  });
  if (upGo) upGo.addEventListener('click', function () {
    if (!pending) return;
    upGo.disabled = true;
    var job = pending;
    post('cart/change.js', { id: job.key, quantity: 0 })
      .then(function () { return post('cart/add.js', { items: [{ id: job.id, quantity: 1 }] }); })
      .then(refresh).catch(refresh)
      .finally(function () { upGo.disabled = false; });
  });
})();

/* Background videos: only play while on screen */
(function () {
  'use strict';
  var vids = document.querySelectorAll('video[data-autoplay-inview]');
  if (!vids.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  Array.prototype.forEach.call(vids, function (v) {
    v.muted = true;
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
  });
  if (reduce || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); }
      else e.target.pause();
    });
  }, { threshold: 0.2 });
  Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
})();
